import { mountStoreDevtool } from 'simple-zustand-devtools';
import { create } from 'zustand';

import config from '@src/configs/chapter';

export type State = {
	zenotiUrl: string;
	zenotiApiKey: string;
	googleMapApiKey: string;
	featureFlags: any;
};

export type Actions = {
	setZenotiUrl: (url: string) => void;
	setZenotiApiKey: (apiKey: string) => void;
	setGoogleMapApiKey: (apiKey: string) => void;
	setFeatureFlags: (featureFlags: any) => void;
};

const useAppStore = create<State & Actions>((set) => ({
	zenotiUrl: 'https://api.zenotistage.com/v1', // default to stage
	zenotiApiKey: '027aa4d4a5ea41839e9013258a21da0f87d6fefa34884461ab23094f410ceb51', // default to stage
	googleMapApiKey: config.services.nonprod.GOOGLE_MAP_API_KEY,
	featureFlags: {},
	setZenotiUrl: (url) => set({ zenotiUrl: url }),
	setZenotiApiKey: (apiKey) => set({ zenotiApiKey: apiKey }),
	setGoogleMapApiKey: (googleMapApiKey) => set({ googleMapApiKey }),
	setFeatureFlags: (featureFlags) => set({ featureFlags }),
}));

if (process.env.NODE_ENV === 'development') {
	mountStoreDevtool('appStore', useAppStore);
}

export default useAppStore;
